import * as React from "react";

import { createSvgIcon } from "@mui/material/utils";

const Achievement1Icon = createSvgIcon(
    <svg
        width="160"
        height="160"
        viewBox="0 0 160 160"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="80" cy="80" r="80" fill="url(#paint0_linear_5305_1562)" />
        <g filter="url(#filter0_i_5305_1562)">
            <circle
                cx="80"
                cy="80"
                r="67"
                fill="url(#paint1_linear_5305_1562)"
            />
        </g>
        <circle cx="80" cy="80" r="67" stroke="#842F10" strokeWidth="3" />
        <g filter="url(#filter1_d_5305_1562)">
            <path
                d="M78.2065 51.634C78.9402 50.1475 81.0598 50.1475 81.7935 51.634L88.9392 66.1128C89.2305 66.7031 89.7937 67.1123 90.4451 67.2069L106.423 69.5287C108.064 69.7671 108.719 71.783 107.532 72.9401L95.9698 84.2103C95.4985 84.6698 95.2834 85.3318 95.3946 85.9806L98.1241 101.894C98.4043 103.528 96.6894 104.774 95.2222 104.003L80.9307 96.4893C80.348 96.183 79.652 96.183 79.0693 96.4893L64.7778 104.003C63.3106 104.774 61.5957 103.528 61.8759 101.894L64.6054 85.9806C64.7166 85.3318 64.5015 84.6698 64.0302 84.2103L52.4681 72.9401C51.2811 71.783 51.9361 69.7671 53.5765 69.5287L69.5549 67.2069C70.2063 67.1123 70.7695 66.7031 71.0608 66.1128L78.2065 51.634Z"
                fill="#F29441"
            />
            <path
                d="M78.8789 51.9658C79.3088 51.0948 80.5004 51.0404 81.0254 51.8027L81.1211 51.9658L88.2666 66.4443C88.6422 67.2053 89.3463 67.7479 90.1709 67.9199L90.3369 67.9492L106.315 70.2705C107.277 70.4102 107.697 71.5269 107.134 72.2617L107.009 72.4033L95.4463 83.6729C94.8386 84.2652 94.5405 85.1029 94.6318 85.9404L94.6553 86.1074L97.3848 102.021C97.5488 102.979 96.6169 103.723 95.7441 103.415L95.5713 103.339L81.2793 95.8252C80.5283 95.4305 79.6401 95.4055 78.8721 95.751L78.7207 95.8252L64.4287 103.339C63.5691 103.791 62.5738 103.135 62.5967 102.21L62.6152 102.021L65.3447 86.1074C65.4882 85.2711 65.2369 84.4188 64.6709 83.7949L64.5537 83.6729L52.9912 72.4033C52.2959 71.7255 52.6123 70.5756 53.499 70.3115L53.6846 70.2705L69.6631 67.9492C70.5028 67.8271 71.236 67.3249 71.6543 66.5938L71.7334 66.4443L78.8789 51.9658Z"
                stroke="#842F10"
                strokeWidth="1.5"
            />
        </g>
        <defs>
            <filter
                id="filter0_i_5305_1562"
                x="11.5"
                y="11.5"
                width="141"
                height="141"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="4" dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                />
                <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_5305_1562"
                />
            </filter>
            <filter
                id="filter1_d_5305_1562"
                x="46.8619"
                y="44.5191"
                width="68.2761"
                height="65.7179"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="1" />
                <feGaussianBlur stdDeviation="3" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_5305_1562"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_5305_1562"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_5305_1562"
                x1="0"
                y1="0"
                x2="160"
                y2="164"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FFAB4D" />
                <stop offset="1" stopColor="#CC621A" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_5305_1562"
                x1="13"
                y1="13"
                x2="147"
                y2="147"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#D06615" />
                <stop offset="1" stopColor="#A04109" />
            </linearGradient>
        </defs>
    </svg>,
    "Achievement1Icon",
);

export default Achievement1Icon;
